import type { SupportedLocale } from '@99designs/i18n';
import type { ProductKey } from '../../../products/types';

export const popularProductKeys: Record<string, Record<SupportedLocale, ProductKey[]>> = {
    packaging: {
        'da-DK': [],
        'de-AT': [],
        'de-CH': [],
        'de-DE': [],
        'en-AU': [],
        'en-CA': [],
        'en-GB': [],
        'en-IE': [],
        'en-IN': [],
        'en-NZ': [],
        'en-SG': [],
        'en-US': ['displayMailers', 'hangTags', 'standUpPouches', 'productBoxes'],
        'es-ES': [],
        'es-US': [],
        'fi-FI': [],
        'fr-BE': [],
        'fr-CA': [],
        'fr-CH': [],
        'fr-FR': [],
        'it-CH': [],
        'it-IT': [],
        'nb-NO': [],
        'nl-BE': [],
        'nl-NL': [],
        'pt-PT': [],
        'sv-SE': [],
    },
};
